const detail = {
  line1: [
    {
      name: 'supplierName',
      text: 'order.order_supplier-name',
      component: 'MultipleSelectSupplierName'
    },
    {
      name: 'loadingDate',
      text: 'loading.loading_loading-date',
      component: 'FromToDatePicker'
    },
    {
      name: 'loadingStorage',
      text: 'loading.loading_loading-storage',
      component: 'SelectStorageName',
      hasDefault: false,
      cols: 5
    },
    {
      name: 'loadingStatus',
      text: 'order.order_loading-status',
      component: 'SelectStatusOrder',
      type: 4,
      cols: 4
    }
  ],
  line2: [
    {
      name: 'orderInfo',
      text: 'order.order_order-info',
      component: 'SearchTwinTextboxInfo'
    },
    {
      name: 'productInfo',
      text: 'sale.sale_product-info',
      component: 'SearchProductNoAndProductCategory'
    }
  ]
}

export default { detail }
